import { observer } from "mobx-react-lite";

export default function genericObserver<
	T extends React.FC<P>,
	P extends object = T extends React.FC<infer P> ? P : unknown
>(fn: T): T {
	return observer<P>(fn) as T;
}
